export default {
  TableHead: [
    [
      {
        displayName: 'documentapi.documentapihead.number',
      },
      {
        displayName: 'documentapi.documentapihead.provider',
      },
      {
        displayName: 'documentapi.documentapihead.documentseamless',
      },
      {
        displayName: 'documentapi.documentapihead.documenttransfer',
      },
      {
        displayName: 'documentapi.documentapihead.assest',
      },
      {
        displayName: 'documentapi.documentapihead.edit',
        isAgentHidden: true,
      },
      {
        displayName: 'documentapi.documentapihead.delete',
        isAgentHidden: true,
      },
    ],
  ],
};
